import { ReactElement, ReactNode } from 'react';

import { rem, Flex, Button } from '@vimeo/bokeh';
import { Plus } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../utils/dom/identifying';

interface ICreateButtonMinimizedProps extends IBaseDomElementProps {
  isDisabled?: boolean;
  icon?: ReactElement;
  children: ReactNode;
  withBottomMargin?: boolean;
  onClick?: () => void;
}

export function CreateButtonMinimized({
  id = createDomName('create-button-minimized'),
  className = createDomName('create-button-minimized'),
  isDisabled,
  withBottomMargin,
  icon = <Plus width={rem(16)} maxWidth={rem(16)} />,
  children,
  onClick,
}: ICreateButtonMinimizedProps) {
  return (
    <Flex
      id={id}
      className={className}
      alignItems={'center'}
      borderRadius={rem(4)}
      justifyContent={'center'}
      color={'stroke'}
      margin={`${rem(16)} 0 ${withBottomMargin ? rem(16) : 0} 0`}
    >
      <Button
        id={createDomName(id, 'target')}
        className={createDomName(className, 'target')}
        variant={'primary'}
        isDisabled={isDisabled}
        leftIcon={icon}
        width={'100%'}
        onClick={onClick}
      >
        {children}
      </Button>
    </Flex>
  );
}
